export const validPhoneNumber = (phoneNumber: string) => {
  const removeHyphenNumber = (phoneNumber = phoneNumber.replace(new RegExp('-', 'g'), ''));
  return /(^(010|011|016|017|018|019)[0-9]{3,4}[0-9]{4}$)/g.test(removeHyphenNumber);
};
